<template>
    <p class="page-label">{{ label }}</p>
</template>
<script>
export default {
    props: ['label']
};
</script>
<style>
.page-label {
    background: #f3f3f3;
    color: #565656;
    font-weight: bold;
    font-size: 16px;
    border-radius: 0px 0px 10px 10px;
    padding: 15px 40px;
}
</style>
